<div class="container">
    <app-section-header
        title="{{ contact?.fullName }}"
        subTitle="Contacts"
        [actionsTemplate]="actionsTemplate"
        [iconName]="'goBack'"
        [mainAdditionalTemplate]="statusTemplate"
    >
        <ng-template #statusTemplate>
            @if (!isActive) {
                <lib-status-indicator
                    [iconName]="'archived'"
                    [colorType]="'error'"
                    [text]="'Archived'"
                ></lib-status-indicator>
            }
        </ng-template>

        <ng-template #actionsTemplate>
            <div class="actions">
                @if (currentTab === 'Overview') {
                    <button class="primary-btn" (click)="onEditContact()">Edit</button>
                }
                <app-kebab-menu>
                    @if (isActive) {
                        <button role="menuitem" class="resetStyles" (click)="archiveContact()">Archive</button>
                    } @else {
                        <button role="menuitem" class="resetStyles" (click)="restoreContact()">Restore</button>
                    }
                </app-kebab-menu>
            </div>
        </ng-template>
    </app-section-header>

    <div class="tabGroup">
        <lib-tab-view
            [(currentTab)]="currentTab"
            (currentTabChange)="tabChange($event)"
            alignment="start"
            separation="wide"
        >
            <lib-tab-item tabName="Overview" [bodyTemplate]="overviewTab">
                <ng-template #overviewTab>
                    <div class="tab" #scrollable>
                        <app-contacts-single-overview
                            [contact]="contact"
                            [isReadOnly]="true"
                            #overview
                        ></app-contacts-single-overview>
                    </div>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Opportunities" [bodyTemplate]="opportunitiesTab" [headerTemplate]="headerTemplate">
                <ng-template #opportunitiesTab>
                    <app-contacts-single-opportunities [contactId]="contactId"></app-contacts-single-opportunities>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Buildings" [bodyTemplate]="buildingsTab" [headerTemplate]="headerTemplate">
                <ng-template #buildingsTab>
                    <app-contacts-single-buildings
                        [contact]="contact"
                        (tabCounterChange)="onTabCountersChange()"
                    ></app-contacts-single-buildings>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Activity Log" [bodyTemplate]="activityLogTab">
                <ng-template #activityLogTab>
                    <app-activity-log-grid [entityId]="contactId" [entityTypeId]="entityTypeId"></app-activity-log-grid>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Notes" [bodyTemplate]="notesTab" [headerTemplate]="headerTemplate">
                <ng-template #notesTab>
                    <app-notes
                        [entityTypeId]="entityTypeId"
                        [entityId]="$safeNavigationMigration(contact?.id)"
                        [entityName]="$safeNavigationMigration(contact?.fullName)"
                        [organizationId]="$safeNavigationMigration(contact?.organizationId)"
                        (tabCounterChange)="onTabCountersChange()"
                    ></app-notes>
                </ng-template>
            </lib-tab-item>

            <ng-template #headerTemplate let-tab="tab">
                <lib-counter-badge
                    [label]="tab.tabName()"
                    [count]="tabsCounters[tab.tabName()] || 0"
                ></lib-counter-badge>
            </ng-template>
        </lib-tab-view>
    </div>
</div>
